<div class="select-ente">
  <span> Selezionare un ente nell'intestazione per abilitare le funzionalità </span>
</div>
